import { Outlet } from "@tanstack/react-router";
import { useGetThemeQuery } from "../../api/branding/branding.hooks";
import { useEffect } from "react";
import { useStore } from "../../store/store";
import { apiURL, applyRootStyles, setFavicon } from "../../utils";
import { useTheme } from "../../components/ui";
import ParticleComponent from "./login/components/ParticleComponents";

export default function AuthLayout() {
  const getBrandingData = useGetThemeQuery(
    {},
    {
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
    },
  );
  const brandingList = useStore((state) => state.brandingList);
  const setBrandingList = useStore((state) => state.setBrandingList);
  const root = window.document.documentElement;
  const { theme } = useTheme();

  useEffect(() => {
    if (getBrandingData?.data?.data) {
      const brandingData = {
        ...getBrandingData?.data?.data,
        primary_color_light:
          getBrandingData?.data?.data?.primary_color_light ??
          brandingList?.primary_color_light,
        primary_color_dark:
          getBrandingData?.data?.data?.primary_color_dark ??
          brandingList?.primary_color_dark,
        secondary_color_light:
          getBrandingData?.data?.data?.secondary_color_light ??
          brandingList?.secondary_color_light,
        secondary_color_dark:
          getBrandingData?.data?.data?.secondary_color_dark ??
          brandingList?.secondary_color_dark,
      };
      setBrandingList(brandingData);
      applyRootStyles(
        "--primary",
        theme,
        brandingList?.primary_color_light,
        brandingList?.primary_color_dark ?? "",
      );
      applyRootStyles(
        "--secondary",
        theme,
        brandingList?.secondary_color_light,
        brandingList?.secondary_color_dark ?? "",
      );
      setFavicon(
        theme === "dark"
          ? `${apiURL(getBrandingData?.data?.data?.favicon_dark as string).toString() ?? ""}`
          : `${apiURL(getBrandingData?.data?.data?.favicon_light as string).toString() ?? ""}`,
      );
    }
  }, [
    brandingList?.primary_color_dark,
    brandingList?.primary_color_light,
    brandingList?.secondary_color_dark,
    brandingList?.secondary_color_light,
    getBrandingData?.data,
    root.style,
    setBrandingList,
    theme,
  ]);

  return (
    <main>
      <div className="relative min-h-screen overflow-hidden bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="absolute left-0 top-0 z-0 h-full w-1/5 opacity-30">
          <div className="h-full w-full bg-gradient-to-r from-blue-200/20 to-transparent">
            <ParticleComponent />
          </div>
        </div>
        <Outlet />
      </div>
    </main>
  );
}
